import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  withRouter
} from 'react-router-dom';
import Button from '../../atoms/Button';

class Logout extends Component {

  logout = () => {
    this.props.logout();
    this.props.history.push('/');
  }

  render() {
    return (
      <Button className="Logout" onClick={this.logout}>
        Logout
      </Button>
    );
  }

}

Logout.propTypes = {
  logout: PropTypes.func.isRequired,
}

export default withRouter(Logout);



// WEBPACK FOOTER //
// ./src/component/molecules/Logout/component.js